import { Image, message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful, { baseURL } from "../../restful";

interface DataType {
    name: String
    imagename: String
    roile: String
    _id: String
    createdAt: Date
    updatedAt: Date
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const ImagesTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/images/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [

        { sorter: true, title: 'کلید', dataIndex: 'key', key: 'key' },
        {
            title: 'تصویر', dataIndex: 'link', key: 'link',
            // render(val) {
            //     return <Image width={44} src={baseURL + "/" + val} />
            // }
        },
        {
            sorter: true, title: 'انتشار', dataIndex: 'published', key: 'published', width: 100,
            render(val) {
                if (val) return <Tag color="green">منتشر شده</Tag>
                return <Tag color="red">عدم انتشار</Tag>
            },
        },
        // {  defaultSortOrder: 'descend',
        //     sorter: true,   title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 110,
        //     render(val) {
        //         return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
        //     },
        // },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            title: 'عملیات', dataIndex: '_id', key: '_id', width: 100,
            render(val) {
                return <Actions id={val}
                    onEdit={(id: string) => navigate('/images-form?id=' + id)}
                    onDelete={onDeleteAction} />
            }
        },
    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/images/paginate`, { params: {...params, ...filters} })
            .then((res) => {
                const result = res.data.result
                setItems(result.images);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.imagesCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default ImagesTable

